
import { STORAGE_KEYS } from 'config/Constants';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { ecommerce } from 'services/api/e-commerce';

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem(STORAGE_KEYS.USER_DATA);
    return savedUser ? JSON.parse(savedUser) : null;
  });

  useEffect(() => {
    setLoading(false);
  }, []);

  const [authenticationToken, setAuthenticationToken] = useState(() => localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) || null);

  const [refreshToken, setRefreshToken] = useState(() => localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN) || null);

  const login = async(requestBody) => {

    const response = await ecommerce.postSession(requestBody);

    if (response.success && response.data) {
      if (response.data) {
        localStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(response.data.user));
        localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, response.data.authentication_token);
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, response.data.refresh_token);
        setUser(response.data.user)
        setAuthenticationToken(response.data.authentication_token)
        setRefreshToken(response.data.refresh_token)
      }
    }
    return response;

  };

  const logout = async(queryParams) => {
    const response = await ecommerce.deleteSession(queryParams);
    
    if(response.success){
      localStorage.removeItem(STORAGE_KEYS.USER_DATA);
      localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
      localStorage.removeItem(STORAGE_KEYS.CART);
      setUser(null);
      setAuthenticationToken(null);
      setRefreshToken(null)
    }
    return response

  };

  return (
    <AuthContext.Provider value={{ user, authenticationToken, refreshToken, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for easy access
export const useAuth = () => useContext(AuthContext);
